var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rest-info__section" },
    [
      _c("content-container", [
        _c("div", { staticClass: "rest-info__title-wrapper" }, [
          !_vm.isPartner
            ? _c("i", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.nonPartnerMessage,
                    expression: "nonPartnerMessage",
                  },
                ],
                staticClass: "fas fa-info-circle non-partner-info",
              })
            : _vm._e(),
          _vm._v(" "),
          _c("h2", { staticClass: "rest-info__title" }, [
            _vm._v("\n        " + _vm._s(_vm.name) + "\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "rest-info__more-info-wrapper" },
          [
            _c(
              "a",
              {
                staticClass:
                  "rest-info__info rest-info__back-link rest-info__flex",
                attrs: { href: "/" + _vm.cityName + "/restaurants/" },
              },
              [
                _c(
                  "icon-base",
                  {
                    staticClass: "rest-info__back-arrow-icon",
                    attrs: {
                      width: "16px",
                      height: "14px",
                      iconName: "Back to All Restaurants",
                    },
                  },
                  [_c("icon-arrow-right")],
                  1
                ),
                _vm._v(" "),
                _c("span", [_vm._v("Back to All Restaurants")]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-popover",
              {
                attrs: {
                  open: _vm.showDelTimePopover,
                  popoverInnerClass: "popover-inner",
                  popoverBaseClass: ["popover", "tooltip", "del-time-base"],
                },
              },
              [
                _vm.deliveryTime.type === "asap" && _vm.waitTime
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "rest-info__info rest-info__line rest-info__flex",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "del-time-popover-btn",
                            attrs: { "aria-label": "Update Delivery Time" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.toggleDelTimePopover.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("flying-fork-dark", {
                              staticClass: "rest-info__flyingfork-icon",
                            }),
                            _vm._v(
                              "\n            Estimate: " +
                                _vm._s(_vm.waitTime) +
                                " minutes\n          "
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.deliveryTime.type === "later" && _vm.deliveryTime.time
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "rest-info__info rest-info__line rest-info__flex",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "del-time-popover-btn",
                            attrs: { "aria-label": "Update Delivery Time" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.toggleDelTimePopover.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "icon-base",
                              {
                                staticClass: "rest-info__clock-icon",
                                attrs: {
                                  width: "20px",
                                  height: "20px",
                                  iconName: "clock",
                                },
                              },
                              [_c("icon-clock")],
                              1
                            ),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.deliveryTime.time) +
                                "\n          "
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("template", { slot: "popover" }, [
                  _c("div", { staticClass: "del-time-prompt" }, [
                    _vm._v("When would you like it delivered?"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "del-time-buttons-wrapper" }, [
                    _c(
                      "button",
                      {
                        class: [
                          "del-time-btn",
                          {
                            delTimeSelected: _vm.deliveryTime.type !== "later",
                          },
                        ],
                        attrs: {
                          "aria-label": "Set delivery as soon as possible.",
                        },
                        on: { click: _vm.handleDeliveryASAP },
                      },
                      [
                        _c("flying-fork-dark", {
                          staticClass: "rest-info__flyingfork-icon",
                        }),
                        _vm._v("ASAP\n            "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        class: [
                          "del-time-btn",
                          {
                            delTimeSelected: _vm.deliveryTime.type === "later",
                          },
                        ],
                        attrs: { "aria-label": "Update Delivery Time" },
                        on: { click: _vm.handleDelTimeUpdate },
                      },
                      [
                        _c(
                          "icon-base",
                          {
                            staticClass: "rest-info__clock-icon",
                            attrs: {
                              width: "20px",
                              height: "20px",
                              iconName: "clock",
                            },
                          },
                          [_c("icon-clock")],
                          1
                        ),
                        _vm._v(
                          "\n              Schedule Delivery\n            "
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "rest-info__more-button rest-info__line",
                on: {
                  click: function ($event) {
                    return _vm.handleInfoOpen()
                  },
                },
              },
              [_vm._v("More Info +")]
            ),
            _vm._v(" "),
            _vm.tags
              ? _c(
                  "div",
                  { staticClass: "rest-info__line rest-info__info" },
                  _vm._l(_vm.tags, function (tag, index) {
                    return _c(
                      "span",
                      { key: tag, staticClass: "rest-info__tag" },
                      [
                        _vm._v("\n          " + _vm._s(tag)),
                        index < _vm.tags.length - 1
                          ? _c("span", [_vm._v(",")])
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.deliveryCost
              ? _c(
                  "div",
                  {
                    staticClass:
                      "rest-info__info rest-info__line rest-info__flex",
                  },
                  [
                    _vm._v(
                      "\n        $" +
                        _vm._s(_vm.deliveryCost) +
                        " Delivery\n        "
                    ),
                    _vm.distance
                      ? _c("span", { staticClass: "rest-info__distance" }, [
                          _vm._v(_vm._s(_vm.distance) + " miles away"),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showMenuEditLink
              ? _c(
                  "a",
                  {
                    staticClass:
                      "rest-info__info rest-info__line rest-info__back-link rest-info__flex edit-menu-link",
                    attrs: { href: "/restMenuEdit.pl?restId=" + _vm.restId },
                  },
                  [
                    _c("i", { staticClass: "far fa-edit" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Edit Menu")]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }